import { type Signal, computed, signal } from "@preact/signals-react";

export class MarketQuote {
  private readonly pricePrev: Signal<number> = signal(NaN);

  public readonly price: Signal<string> = signal("");

  private readonly priceAsNumber: Signal<number> = computed(() => Number(this.price.value));

  public readonly priceUp: Signal<boolean> = computed(() => this.priceAsNumber.value > this.pricePrev.value);

  public readonly priceDown: Signal<boolean> = computed(() => this.priceAsNumber.value < this.pricePrev.value);

  constructor(
    public readonly type: string,
    public readonly symbol: string,
  ) {}

  public setPrice(price: string): void {
    if (this.price.value === price) {
      return;
    }
    this.pricePrev.value = this.priceAsNumber.value;
    this.price.value = price;
  }
}
